import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=2b35e264&"
import script from "./CompanyData.vue?vue&type=script&lang=ts&"
export * from "./CompanyData.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyData.vue?vue&type=style&index=0&id=2b35e264&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports